import merge from 'lodash/merge';
import { useMemo } from 'react';
import * as Y from 'yjs';

import { ActivityThemeStyles, defaultActivityThemeStyles } from 'external-modules/ui';

import { useParentTheme } from './useParentTheme';
import { getRootMap, useObservedProperty } from '@/utils/yjs';

export function useActivityThemeStyles(document: Y.Doc) {
  const { data: parentTheme } = useParentTheme();

  const rootMap = getRootMap(document);
  const [activityThemeStyles, setActivityThemeStyles] = useObservedProperty<
    ActivityThemeStyles | Record<string, never>
  >(rootMap, 'activityThemeStyles');

  return useMemo(
    () =>
      [
        merge({}, defaultActivityThemeStyles, parentTheme?.styles, activityThemeStyles),
        setActivityThemeStyles
      ] as const,
    [activityThemeStyles, parentTheme?.styles, setActivityThemeStyles]
  );
}
